import {
    EnsAlertTemplate,
    SaveEnsAlertTemplateRequest,
} from "../../../store/features/ens/types";
import {normalizeEscalationLevels} from "../CreateAlertWizard/utils";

export const templateKey = (template: EnsAlertTemplate): string =>
    template.id?.toString() ?? template.systemKey ?? template.name;

export const isCustomTemplate = (template: EnsAlertTemplate): boolean => !template.system;

export const filterTemplates = (
    templates: readonly EnsAlertTemplate[],
    phrase: string,
    includeSystem: boolean,
): EnsAlertTemplate[] => {
    const normalizedPhrase = phrase.trim().toLowerCase();

    return templates.filter((template) => {
        if (!includeSystem && template.system) return false;
        if (!normalizedPhrase) return true;

        return [
            template.name,
            template.message,
            template.type,
            template.system ? 'system' : 'custom',
        ].some((value) => value.toLowerCase().includes(normalizedPhrase));
    });
};

export const buildSaveTemplateRequest = (template: EnsAlertTemplate): SaveEnsAlertTemplateRequest => ({
    type: template.type,
    name: template.name.trim(),
    message: template.message.trim(),
    targetGroupIds: [...template.targetGroupIds],
    targetUserIds: [...template.targetUserIds],
    levels: normalizeEscalationLevels(template.levels),
    voicePrompt: template.voicePrompt,
    apiTriggerEnabled: template.apiTriggerEnabled,
});
